import { useEffect, useState } from 'react';
import Flag from 'react-world-flags';
import { Navbar, Container, Nav, NavDropdown, Image } from 'react-bootstrap';
import { NavLink, useNavigate } from 'react-router-dom';
import logo from '../../assets/GiantLog-logo.png';
import ChangePasswordModal from '../../pages/ChangePasswordModal';
import { NavBarOutlet } from '../NavBar';
import { getUiInterface } from "../../locales/translationUtils";
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../apis/auth/AuthProvider';

const Header: React.FC = () => {
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const { precisaTrocarSenhaPadrao, senhaPadraoTrocada, logoutAction } = useAuth();

  const handleLogout = async () => {
    await logoutAction();
    navigate('/login');
  };

  const handleOptionSelect = (eventKey: string | null) => {
    if (eventKey === 'logout') {
      handleLogout();
    }
  };

  // Entrou com a senha padrão: abre a troca de senha automaticamente, sem opção de adiar.
  useEffect(() => {
    if (precisaTrocarSenhaPadrao) {
      setShowChangePasswordModal(true);
    }
  }, [precisaTrocarSenhaPadrao]);

  const handleOpenModal = () => setShowChangePasswordModal(true);
  const handleCloseModal = () => setShowChangePasswordModal(false);

  const handleLanguageChange = (lang: string) => {
    i18n.changeLanguage(lang);
  };

  return (
    // O bloco inteiro (topo + barra de navegacao + faixa de emulacao) fica preso no
    // alto: a fixacao mora aqui, e nao na .giant-topbar, porque um elemento sticky so
    // acompanha a rolagem enquanto o proprio pai estiver visivel - e o pai media so a
    // altura das duas barras, entao a fixacao acabava depois de alguns pixels.
    <div className="giant-header">
      <Navbar expand="lg" className="giant-topbar">
        <Container fluid>
          <Navbar.Brand as={NavLink} to="/">
            <Image src={logo} alt="Logo" style={{ width: '100px', height: 'auto' }} />
          </Navbar.Brand>

          {/* giant-header-menus: so pra dar um seletor estavel pro CSS de impressao
              esconder os dois dropdowns sem esconder o logo (Navbar.Brand, ao lado) -
              ver @media print em giant-theme.css. */}
          <Nav className="ms-auto giant-header-menus">
            <NavDropdown
              title={<i className="bi bi-gear-wide fs-4"></i>}
              id="user-menu"
              align="end"
              onSelect={handleOptionSelect}>
              <NavDropdown.Item eventKey="logout">
                {getUiInterface('logout')}
              </NavDropdown.Item>

              <NavDropdown.Item onClick={handleOpenModal}>
                {getUiInterface('changePassword')}
              </NavDropdown.Item>
            </NavDropdown>

            <NavDropdown
              title={<i className="bi bi-globe fs-4"></i>}
              id="language-menu"
              align="end">
              <NavDropdown.Item disabled>
                {i18n.language.toUpperCase()}
              </NavDropdown.Item>
              <NavDropdown.Item onClick={() => handleLanguageChange('pt')}>
                <Flag code="BRA" height="16"/> Português
              </NavDropdown.Item>
              <NavDropdown.Item onClick={() => handleLanguageChange('en')}>
                <Flag code="USA" height="12"/> English
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>

          <ChangePasswordModal
            show={showChangePasswordModal}
            onClose={handleCloseModal}
            obrigatorio={precisaTrocarSenhaPadrao}
            onSuccess={senhaPadraoTrocada}
            onLogout={handleLogout}
          />
        </Container>
      </Navbar>
      <NavBarOutlet />
    </div>
  );
};

export default Header;
